import Grid from "@mui/material/Grid";
import { format, subDays } from "date-fns";
import { useState, useEffect } from "react";
import SoftBox from "components/SoftBox";
import GradientLineChart from "examples/Charts/LineCharts/GradientLineChart";
import GradientLineChartData2 from "./GradientLineChartData2";
import { useLocation } from "react-router-dom";
import { CircularProgress, Box } from "@mui/material";

function Default2() {
  const [gradientLineChartData, setGradientLineChartData] = useState(null);
  const [loading, setLoading] = useState(false);
  const location = useLocation();

  const params = new URLSearchParams(location.search);
  const start_date = params.get("start_date");
  const end_date = params.get("end_date");

  const start = start_date || format(subDays(new Date(), 29), "yyyy-MM-dd");
  const end = end_date || format(new Date(), "yyyy-MM-dd");

  useEffect(() => {
    setLoading(true);
    GradientLineChartData2(start, end)
      .then((data) => setGradientLineChartData(data))
      .finally(() => setLoading(false));
  }, [location.search]); // ensure chart refreshes on query param change

  return (
    <Grid item xs={12} lg={12}>
      {loading ? (
        <Box display="flex" justifyContent="center" alignItems="center" minHeight="300px">
          <CircularProgress color="green" />
        </Box>
      ) : (
        gradientLineChartData && (
          <SoftBox>
            <GradientLineChart
              title="Queries"
              chart={gradientLineChartData}
              dateRange={{ start_date: start, end_date: end }}
            />
          </SoftBox>
        )
      )}
    </Grid>
  );
}

export default Default2;
